module.exports = __webpack_public_path__ + "img/vipbg.0723816f.png";